import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=0d5a3200&"
import script from "./addMember.vue?vue&type=script&lang=js&"
export * from "./addMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports